import { useSelectedVariant } from "./useSelectedVariant"

export const useCurrentPrice = () => {
  const selectedVariant = useSelectedVariant()

  return {
    price: selectedVariant?.price || 0
  }
}